import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { UTCDate } from 'map-wald';
// import * as Plotly from 'plotly.js/dist/plotly-basic';
import * as Plotly from 'plotly.js-dist-min';
import { environment } from '../../environments/environment';

export interface ChartEntry {
  date: UTCDate;
  value: number;
  text?: string;
}

export interface ChartSeries {
  title?: string;
  data: ChartEntry[];
  units: string;
  colour?: string|string[];
  type?: string;
  mode?:string;
  markerSize?:number;
  textposition?:string;
  hoverinfo?:string;
  legend?:boolean;
  line?: {
    dash?:string;
    width?:number;
  }
  fill?:string;
  fillcolor?:string|string[];
}

const MAIN_COLOUR='#3c4172';
const SAT_COLOUR='#dee1ff';

@Component({
  selector: 'app-chart',
  template: `<div class="chart-div"></div>
  `,
  styles: []
})
export class ChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string;
  @Input() axisLabel: string;
  @Input() series: ChartSeries[];
  @Input() x = 'year';
  @Input() y = 'value';
  @Input() height = 200;
  @Input() showLegend = false;
  @Input() weightScale = 1;
  @Input() xAxis = {};
  @Input() yAxis = {};

  constructor(private element: ElementRef) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildChart();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.buildChart();
  }

  private chartNode(): HTMLElement {
    return this.element.nativeElement.querySelector('.chart-div');
  }

  buildChart(): void {
    if(!this.series||!this.series.length){
      return;
    }

    //const node = document.getElementById(this.chartId);
    const node = this.chartNode();
    // const chartData = this.series[0].data;
    Plotly.purge(node);

    const series = this.series.map((chartData,ix)=>{
      const col = chartData.colour || (ix ? SAT_COLOUR : MAIN_COLOUR);
      return {
        x: chartData.data.map(r=>(r as any)[this.x]),
        y: chartData.data.map(r=>(r as any)[this.y]),
        text: chartData.data[0].text?chartData.data.map(r=>r.text):undefined,
        textposition: chartData.textposition,
        name: chartData.title,
        type: chartData.type || 'line',
        mode: chartData.mode || 'lines+markers',
        fill: chartData.fill,
        fillcolor: chartData.fillcolor,
        hoverinfo: chartData.hoverinfo,
        connectgaps: true,
        marker: {
          size: chartData.markerSize===undefined ? (ix ? 2 : 3) : chartData.markerSize,
          color: chartData.type==='bar'?col:'rgba(0,0,0,1)',
          line: {
            color: col,
            width: 1
          }
        },
        line: {
          color: col,
          width: 2.5 * this.weightScale,
          ...chartData.line
        },
        showlegend: chartData.legend
      };
    }).reverse();

    const axisTitle = this.axisLabel || this.series[0].units || '';
    const tickSuffix = (this.series[0].units && (this.series[0].units.length<=1)) ? this.series[0].units : '';
    Plotly.newPlot(node, series as Plotly.PlotData[], {
      margin: {
        t: 40,
        l: this.weightScale * (axisTitle ? 70 : 50),
        r: 15,
        b: 30
      },
      yaxis: {
        hoverformat: '.2f',
        title: axisTitle,
        fixedrange: true,
        linewidth: 1 * this.weightScale,
        ticksuffix: tickSuffix,
        ticklen: 4 * this.weightScale,
        titlefont: {
          size: 16 * this.weightScale,
          // color: 'red'
        },
        ...this.yAxis
      },
      xaxis: {
        linewidth: 1 * this.weightScale,
        ...this.xAxis
      },
      height: this.height,
      // width: 520, //600,
      title: this.title,
      showlegend: this.showLegend,
      legend: {

        orientation: 'h',
        y: -0.2
      },
      font: {
        family: environment.fontFamily,
        size: 12*this.weightScale,
        color: '#333'
      }
    },
    {
      displaylogo: false,
      displayModeBar: false,
      modeBarButtonsToRemove: ['hoverCompareCartesian', 'hoverClosestCartesian',
        'lasso2d', 'select2d', 'toggleSpikelines', 'resetViews', 'sendDataToCloud',
        'zoom2d', 'pan2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d',
        'toImage']
    });
  }

  downloadImage(label?:string): void {
    let fn = 'gwm-';
    if(label){
      fn += '-'+label.toLowerCase().replace(/[^a-z0-9]/g,'-');
    }
    if(this.title){
      fn += this.title.toLowerCase().replace(/[^a-z0-9]/g,'-');
    }
    if(this.axisLabel){
      fn += '-'+this.axisLabel.toLowerCase().replace(/[^a-z0-9]/g,'-');
    }
    const node = this.chartNode();
    Plotly.downloadImage(node, {
      filename: fn,
      format: 'png',
      width: 1000,
      height: 800
    });
  }
}

